import { DynamicStandaloneArticle } from '@/components/Article';
import { LabradorComponent } from '@/types/component';

export const LabradorArticle: LabradorComponent = ({ data, meta, descendants, ...props }) => {
  const { nativeAdLabel, isNativeAd } = meta ?? {};
  const { affiliateLabel, hasAffiliate, badgeData } = data ?? {};
  const { name: badgeName } = badgeData ?? {};
  const articleDisclosureLabels = [];

  if (isNativeAd && nativeAdLabel) {
    articleDisclosureLabels.push(nativeAdLabel);
  }

  if (hasAffiliate && affiliateLabel) {
    articleDisclosureLabels.push(affiliateLabel);
  }

  return (
    <DynamicStandaloneArticle
      hide={{ badge: true }}
      badge={{ fragment: badgeName }}
      {...{ descendants, articleDisclosureLabels }}
      {...props}
    />
  );
};

export default LabradorArticle;
